import React, { useState } from 'react';
import StepOne from './StepOne';
import StepTwo from './StepTwo';
import StepThree from './StepThree';
import './style.scss';
import StepFour from './StepFour';

const LimitForm = ({
  t,
  setActiveStep,
  activeStep,
  countriesEndpoint,
  ExtraUserDetailsEndpoint,
  IsMockExtraUserDetailsEndpoint,
  GenerateOTPEndpoint,
  IsMockGenerateOTPEndpoint,
  GenerateOTPToken,
  VerifyOTPEndpoint,
  IsMockVerifyOTPEndpoint,
  SubmitInternationalLimitEndpoint,
  limitationMessage,
  timeoutErrorMessage,
  verificationCodeExpiredErrorMessage,
  timeout,
  otpVerificationCode,
  otpDidNotReceiveText,
  otpSendNewCodeText,
}) => {
  const [nationalId, setNationalId] = useState('');
  const [passportNumber, setPassportNumber] = useState('');
  const [creditCardLastFour, setCreditCardLastFour] = useState('');
  const [extraUserData, setExtraUserData] = useState({});
  const [generateOTPResponse, setGenerateOTPResponse] = useState();
  const [verifyOTPResponse, setVerifyOTPResponse] = useState();
  const [referenceNumber, setReferenceNumber] = useState('');
  const [emailErrorMessage, setEmailErrorMessage] = useState('');
  const [guid, setGuid] = useState('');

  const [trips, setTrips] = useState([
    { id: 1, expanded: true, Country: '', Inbound: '', Outbound: '' },
  ]);

  const renderStep = () => {
    switch (activeStep) {
      case 1:
        return (
          <StepOne
            nationalId={nationalId}
            setNationalId={setNationalId}
            passportNumber={passportNumber}
            setPassportNumber={setPassportNumber}
            creditCardLastFour={creditCardLastFour}
            setCreditCardLastFour={setCreditCardLastFour}
            extraUserData={extraUserData}
            setExtraUserData={setExtraUserData}
            generateOTPResponse={generateOTPResponse}
            setGenerateOTPResponse={setGenerateOTPResponse}
            setActiveStep={setActiveStep}
            ExtraUserDetailsEndpoint={ExtraUserDetailsEndpoint}
            IsMockExtraUserDetailsEndpoint={IsMockExtraUserDetailsEndpoint}
            setGuid={setGuid}
            t={t}
          />
        );
      case 2:
        return (
          <StepTwo
            setActiveStep={setActiveStep}
            t={t}
            countriesEndpoint={countriesEndpoint}
            nationalId={nationalId}
            setNationalId={setNationalId}
            passportNumber={passportNumber}
            setPassportNumber={setPassportNumber}
            creditCardLastFour={creditCardLastFour}
            setCreditCardLastFour={setCreditCardLastFour}
            extraUserData={extraUserData}
            setExtraUserData={setExtraUserData}
            generateOTPResponse={generateOTPResponse}
            setGenerateOTPResponse={setGenerateOTPResponse}
            trips={trips}
            setTrips={setTrips}
            ExtraUserDetailsEndpoint={ExtraUserDetailsEndpoint}
            IsMockExtraUserDetailsEndpoint={IsMockExtraUserDetailsEndpoint}
            GenerateOTPEndpoint={GenerateOTPEndpoint}
            IsMockGenerateOTPEndpoint={IsMockGenerateOTPEndpoint}
            GenerateOTPToken={GenerateOTPToken}
            guid={guid}
            setGuid={setGuid}
          />
        );
      case 3:
        return (
          <StepFour
            t={t}
            setActiveStep={setActiveStep}
            extraUserData={extraUserData}
            setExtraUserData={setExtraUserData}
            generateOTPResponse={generateOTPResponse}
            setGenerateOTPResponse={setGenerateOTPResponse}
            verifyOTPResponse={verifyOTPResponse}
            setVerifyOTPResponse={setVerifyOTPResponse}
            referenceNumber={referenceNumber}
            setReferenceNumber={setReferenceNumber}
            setEmailErrorMessage={setEmailErrorMessage}
            nationalId={nationalId}
            passportNumber={passportNumber}
            creditCardLastFour={creditCardLastFour}
            trips={trips}
            GenerateOTPEndpoint={GenerateOTPEndpoint}
            IsMockGenerateOTPEndpoint={IsMockGenerateOTPEndpoint}
            GenerateOTPToken={GenerateOTPToken}
            VerifyOTPEndpoint={VerifyOTPEndpoint}
            IsMockVerifyOTPEndpoint={IsMockVerifyOTPEndpoint}
            SubmitInternationalLimitEndpoint={SubmitInternationalLimitEndpoint}
            limitationMessage={limitationMessage}
            timeoutErrorMessage={timeoutErrorMessage}
            verificationCodeExpiredErrorMessage={verificationCodeExpiredErrorMessage}
            timeout={timeout}
            otpVerificationCode={otpVerificationCode}
            otpDidNotReceiveText={otpDidNotReceiveText}
            otpSendNewCodeText={otpSendNewCodeText}
            guid={guid}
          />
        );
      case 4:
        return (
          <StepThree
            setActiveStep={setActiveStep}
            t={t}
            referenceNumber={referenceNumber}
            emailErrorMessage={emailErrorMessage}
          />
        );

      default:
        return null;
    }
  };

  return <div className="FormContainer">{renderStep()}</div>;
};

export default LimitForm;
